import {zDateTime, zNumberToString} from '@brunata-angular/util';
import {z} from 'zod';

const measuringPointSchema = z
    .object({
        meterSequenceNo: zNumberToString,
        meterId: z.string().optionalUntilDeployed('AGI-20300'),
        propertyNo: z.string().nullable(),
        branchNo: z.string().nullable(),
        locationNo: z.string().nullable(),
        consumerName: z.string().nullable(),
        address: z.string().nullable(),
        serialNo: z.string().nullable(),
        connectedTo: z.string().nullable(),
        roomId: z.string().nullable(),
        alloUnitType: z.string(),
        meterSuperTypeNo: z.number().nullable(),
        mountingDate: zDateTime.nullable(),
        dismountedDate: zDateTime.nullable(),
        unitFactor: z.number().nullable(),
        scale: z.number().nullable(),
        transmitting: z.boolean().optionalUntilDeployed('AGI-20300'),
        unit: z.number().nullable(),
        readingDate: zDateTime.nullable(),
        meterValue: z.number().nullable(),
    })
    .transform(data => ({
        ...data,
        proBraLoc: `${data.propertyNo ?? ''}-${data.branchNo ?? ''}-${data.locationNo ?? ''}`,
    }));
export type MeasuringPoint = z.infer<typeof measuringPointSchema>;
export const measuringPointsSchema = z
    .object({
        measuringPoints: z.array(measuringPointSchema),
    })
    .transform(data => data.measuringPoints);
